<template>
  <el-dialog
    :visible.sync="dialogVisible"
    fullscreen
    style="z-index: 3000"
    :modal="false"
    :show-close="false"
    :before-close="handleClose"
  >
    <template v-slot:title/>
    <div class="map_body">
      <div id="dialogMapSelectId" ref="allmap" class="bm-view"></div>
      <div class="search">
        <div class="operate_row">
          <DyPoiSearch
            v-model="search"
            :map="map"
            placeholder="请输入地址"
            style="width: 100%"
            :center="center"
            :bounds="bounds"
            @change="handleSelectChange"
          />
        </div>
        <div class="operate_row">
          <el-input
            disabled
            maxlength="50"
            :value="`${this.longitude},${this.latitude}`"
            style="margin-right: 10px"
          />
          <el-button @click="handleClose">取消</el-button>
          <el-button
            type="primary"
            @click="handleConfirm"
            :disabled="!latitude || !longitude"
          >确认
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>

import DyDialog from "@/components/DYDialog/index.vue";

export default {
  name: "DyLngLatSelectDialog",
  components: {DyDialog},
  data() {
    return {
      dialogVisible: false,
      longitude: "",
      latitude: "",
      locationName: "",
      search: "",
      map: undefined,
    };
  },
  computed: {
    center() {
      return this.map?.getCenter()
    },
    bounds() {
      return this.map?.getBounds()
    }
  },
  methods: {
    open(params) {
      const {resolve, cancel} = params || {}
      this.dialogVisible = true
      this.resolve = resolve
      this.cancel = cancel
      setTimeout(() => {
        this.initMap()
      }, 500)
    },
    async initMap() {
      if (!this.map) {
        const map = new window.TMap.Map("dialogMapSelectId", {
          minZoom: 4,
          maxZoom: 16,
        });
        const lnglat = new window.TMap.LngLat(116.40969, 39.89945);
        map.centerAndZoom(lnglat, 12);
        map.disableDoubleClickZoom();
        map.addEventListener("click", this.mapClick);
        this.map = map;
        //h5定位
        // const geolocation = new window.TMap.Geolocation();
        // const options = {
        //   enableHighAccuracy: true,
        //   maximumAge: 0,//0为立即返回
        //   timeout: 10,
        // };
        // geolocation.getCurrentPosition(function (e) {
        //   debugger;
        //   console.log("local2", e);
        //   const statusCode = geolocation.getStatus();
        //   console.log("statusCode", statusCode);
        // }, options);
      }
      setTimeout(() => {
        //ip定位
        const localCity = new window.TMap.LocalCity();
        localCity.location(function (e) {
          console.log("localCity", e);
          this.map.centerAndZoom(e.lnglat, 12);
        });
      }, 1000);
    },
    mapClick(event) {
      const marker = new window.TMap.Marker(event.lnglat);
      this.longitude = event.lnglat.lng;
      this.latitude = event.lnglat.lat;
      this.map.clearOverLays();
      this.map.addOverLay(marker);

      axios.get(`https://api.tianditu.gov.cn/geocoder?postStr={lon:${event.lnglat.lng},lat:${event.lnglat.lat},ver:1}&type=geocode&tk=d02eaddf056c6f34ad9bd73eeca5f7fa`).then(res => {
        this.search = res.data.result.formatted_address
        this.locationName = res.data.result.formatted_address
      })
    },
    handleClose() {
      if (this.marker) {
        this.marker.setMap(null);
        this.marker = null;
      }
      this.latitude = "";
      this.longitude = "";
      this.dialogVisible = false;
      this.map = undefined
      this.cancel && this.cancel()
    },
    handleConfirm() {
      const res = {
        longitude: this.longitude,
        latitude: this.latitude,
        location: this.locationName
      }
      this.$emit("confirm", res);
      this.resolve && this.resolve(res)
      this.handleClose();
    },
    handleSelectChange(val) {
      const lonlatArr = val.lonlat.split(",");
      const lnglat = new window.TMap.LngLat(lonlatArr[0], lonlatArr[1]);
      this.map.centerAndZoom(lnglat, 12);
      this.longitude = lonlatArr[0];
      this.latitude = lonlatArr[1];
      this.locationName = val.name
      this.createMarker(this.longitude, this.latitude);
    },
    createMarker(lng, lat) {
      const marker = new window.TMap.Marker(new window.TMap.LngLat(lng, lat));
      this.map.clearOverLays();
      this.map.addOverLay(marker);
    },
  },
};
</script>

<style lang="scss" scoped>
.map_body {
  position: relative;
  width: 100%;

  .bm-view {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column-reverse;
  }

  .search {
    z-index: 999;
    position: absolute;
    right: 10px;
    bottom: 20px;
    border-radius: 0.4rem;
    box-shadow: 0 2px 6px 0 rgba(114, 124, 245, 0.5);
    background: white;

    .operate_row {
      display: flex;
      padding: 10px 20px;
    }
  }
}

::v-deep .el-dialog__body {
  height: 100vh;
  width: 100vw;
}

::v-deep .el-dialog__header {
  display: none;
}
</style>
